import React, { useEffect, useId, useState } from 'react';
import './ProgressiveDisclosure.css';

const storageKey = (id) => `linkload:collapsible:${id}`;

const CollapsibleSection = ({
  id,
  header,
  children,
  defaultExpanded = false,
  persist = true,
  className = '',
  onToggle,
}) => {
  const generatedId = useId();
  const sectionId = id || generatedId;
  const [expanded, setExpanded] = useState(() => {
    if (!persist || typeof window === 'undefined' || !id) {
      return defaultExpanded;
    }
    const saved = window.localStorage.getItem(storageKey(id));
    return saved === null ? defaultExpanded : saved === 'true';
  });

  useEffect(() => {
    if (persist && typeof window !== 'undefined' && id) {
      window.localStorage.setItem(storageKey(id), String(expanded));
    }
    onToggle?.(expanded);
  }, [expanded, id, onToggle, persist]);

  return (
    <section className={`collapsible-section ${className}`}>
      <button
        type="button"
        className="collapsible-section__button"
        aria-expanded={expanded}
        aria-controls={`${sectionId}-panel`}
        onClick={() => setExpanded((value) => !value)}
      >
        <span>{header}</span>
        <span className="collapsible-section__icon" aria-hidden="true">⌄</span>
      </button>
      {expanded && (
        <div id={`${sectionId}-panel`} className="collapsible-section__content">
          {children}
        </div>
      )}
    </section>
  );
};

export default CollapsibleSection;

